//@flow

export const ON_BOARDING_FIELDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  STORE_NAME: 'storeName',
  STORE_TYPE: 'storeType',
  STORE_GOAL: 'storeGoal',
  WEEKLY_SALES: 'weeklySales',
  SUPPORT_INFORMATION: 'supportInformation',
  REFERRAL_INFORMATION: 'referralInformation',
  STORE_INTEREST: 'storeInterest',
  STORE_BUSINESS_TYPE: 'storeBusinessType',
};

export const ON_BOARDING_TYPE = {
  FREE_TRIAL: 1,
  FULL_PAYMENT: 4,
};
